import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'activityListFilter'
})
export class ActivityListFilterPipe implements PipeTransform {

  transform(activity: any, params: any): any {
    const activities = activity;
    const diff = moment(params.endDate ? params.endDate : params.startDate).diff(params.startDate, "days");
    const firstDay = moment(params.startDate);
    let weekdaysBetween = [];
    if (diff >= 6) {
      weekdaysBetween = [0, 1, 2, 3, 4, 5, 6];
    } else {
      for (let i = 0; i <= diff; i++) {
        weekdaysBetween.push(moment(firstDay).add(i, "days").day());
      }
    }
    var dateFilteredActivity = activities;
    if (!activities) {
      return [];
    } else if (!params.startDate && !params.endDate) {
      //return activities;
    } else if (params.startDate && !params.endDate) {
       dateFilteredActivity = activities.filter(eachActivity => {
        if (eachActivity.StartDate && eachActivity.EndDate) {
          return moment(eachActivity.StartDate?.split('T')[0]).isSameOrBefore(moment(params.startDate)) &&
            moment(eachActivity.EndDate?.split('T')[0]).isSameOrAfter(moment(params.startDate)) && eachActivity.ActivityDayOfWeeks?.some(item => weekdaysBetween.includes(item))
        } else {
          return eachActivity;
        }
      });
      //return filteredActivity;
    }
    dateFilteredActivity = activities.filter(eachActivity => {
      if (eachActivity.StartDate && eachActivity.EndDate) {
        return moment(eachActivity.StartDate?.split('T')[0]).isSameOrBefore(moment(params.endDate)) &&
          moment(eachActivity.EndDate?.split('T')[0]).isSameOrAfter(moment(params.startDate)) && eachActivity.ActivityDayOfWeeks?.some(item => weekdaysBetween.includes(item))
      } else {
        return eachActivity;
      }
    });
    //return filteredActivity;

    var nameFilteredActivity = dateFilteredActivity;
    if (params.searchText){
       nameFilteredActivity = dateFilteredActivity.filter(eachActivity => {
        if (eachActivity.Name)
          return eachActivity.Name.toLowerCase().includes(params.searchText.toLowerCase())
        else 
          return false;
      });
    }
    
    return nameFilteredActivity;

    activity.sort((a: any, b: any) => {
      if (a.LessonName.replace(/\s/g, "").toLowerCase() < b.LessonName.replace(/\s/g, "").toLowerCase()) {
        return -1;
      } else if (a.LessonName.replace(/\s/g, "").toLowerCase() > b.LessonName.replace(/\s/g, "").toLowerCase()) {
        return 1;
      } else {
        return 0;
      }
    });
    return activity;
  }

}
